<template>
	<el-tabs class="shangpinBianji">
		<el-tab-pane>
			<span slot="label"><i class="el-icon-document-remove"></i>商品组件</span>
			<div style="padding: 20px;">
				<div>
			<!-- 		<div style="padding-top: 20px;">
						<el-radio-group v-model="value.pailiefangshi">
							<el-radio label="1">一列</el-radio>
							<el-radio label="2">二列</el-radio>
							<el-radio label="3">三列</el-radio>
						</el-radio-group>
					</div>
					<el-divider content-position="left"></el-divider> -->
					<div style="padding-top: 20px;">
						<el-radio-group v-model="value.mokuai">
							<!-- <el-radio label="zw_shangcheng">通用商城</el-radio>
							<el-radio label="zw_pige">线上超市</el-radio> -->
							<el-radio label="limitao">社区团购</el-radio>
							
						</el-radio-group>
					</div>
					<el-divider content-position="left"></el-divider>
					<el-radio-group v-model="value.guding">
						<el-radio label="0">固定</el-radio>
						<el-radio label="1">动态</el-radio>
					</el-radio-group>
					<el-divider content-position="left"></el-divider>

					<!-- <el-checkbox v-model="value.ico" false-label="0" true-label="1">是否显示图标</el-checkbox> -->

					<div v-if="value.guding==1" style="padding-top: 20px;">
						<Liandong :yiji.sync="value.fenlei_yiji" :erji.sync="value.fenlei_erji" :shu="fenleilie" clearable :xiabiao="{value:'id',label: 'ming',children: 'haizi',checkStrictly: true }"></Liandong>
						<div style="margin-top: 20px">
							<el-radio-group v-model="value.biaoqian" size="medium">
								<el-radio-button label="xinpin">新品</el-radio-button>
								<el-radio-button label="tuijian">推荐</el-radio-button>
								<el-radio-button label="miaosha">秒杀</el-radio-button>
							</el-radio-group>
						</div>
					</div>

					<div v-else style="padding-top: 20px;">
						<div style="display: flex;padding-top: 20px;flex-wrap: wrap;">
							<div style="position: relative;" class="tianjiazuhe" v-for="(l,i) in value.shu" v-if="value.shu">
								<el-image style="width: 50px; height: 50px" :src="l.tu" fit="contain"></el-image>
								<div class="tianjiazuhe_Shanchu"><i class="el-icon-circle-close" @click="Shanchu_shu(i)"></i></div>
							</div>
					
							<div style="position: relative;" class="tianjiazuhe_jia" @click="Tiaojia">添加</div>
						</div>

					</div>
				</div>
			</div>

			<el-dialog title="搜索商品" :visible.sync="dialog">
				<div style="margin: 15px 0px;">
				  <el-input placeholder="商品标题" v-model="so.guanjianci">
				    <el-button slot="append" icon="el-icon-search" @click="Tiaojia"></el-button>
				  </el-input>
				</div>
				<el-table :data="shangpin.lie"  @selection-change="handleSelectionChange" >
				    <el-table-column type="selection"  width="55"></el-table-column>
					<el-table-column property="id" label="ID" width="150"></el-table-column>
					<el-table-column property="ming" label="标题" width="400"></el-table-column>
					<el-table-column property="jiage" label="价格"></el-table-column>
			  </el-table>
			   <span slot="footer" class="dialog-footer">
			      <el-button @click="dialog = false">取 消</el-button>
			      <el-button type="primary" @click="Queding">确 定</el-button>
			    </span>
			</el-dialog>
		</el-tab-pane>
		<el-tab-pane>
			<span slot="label"><i class="el-icon-menu"></i> 组件样式</span>
			<!-- <el-input placeholder="请输入内容" v-model="value.yangshi.gao">
				<template slot="prepend">Http://</template>
			</el-input> -->
		</el-tab-pane>
	</el-tabs>
</template>

<script>
	import Liandong from '../Liandong.vue'

	// import Shangpin from 'Shangpin.vue'
	export default {
		name: 'shangpin_bianji',
		data() {
			return {
				fenleilie: [],
				shangpin: [],
				dialog: false,
				so:{
					ye:1,
					jitiao:8
				},
				Xuanzhong:[],
				jiushu:{}
			};
		},
		props: {
			value: {
				type: [Object, Array],
				default () {
					return {

					}
				}
			}
		},
		components: {
			Liandong
		},
		created() {
			this.Fenlei();		
			this.CSH();
		},
		watch:{
			"value.mokuai":function(){								
				this.$set(this.value,'shu',[]);	
				this.CSH();
			},
			"value.guding":function(){
				this.CSH();
			},
			"value.fenlei_yiji":function(){
				this.CSH();
			},
			"value.fenlei_erji":function(){
				this.CSH();
			},
			"value.biaoqian":function(){
				this.CSH();
			}
		},
		methods: {
			CSH(){
				var that=this;
				if(Number(this.value.guding)){
					var shu={ye:1,jitiao:6};
					if(this.value.fenlei_yiji){
						shu['yijifenlei']=this.value.fenlei_yiji;	
					}
					if(this.value.fenlei_erji){
						shu['erjifenlei']=this.value.fenlei_erji;	
					}
					if(this.value.biaoqian){
						shu[this.value.biaoqian]=1;	
					}					
					this.$post("m="+this.value.mokuai+'&k=shangpin',shu,function(s) {
						if (s.shi == 1) {	
							that.value.shu=s.shu.lie;						
						}
					});
				}				
			},
			Fenlei() {
				var that = this;
				this.$post('m=limitao&k=shangpin&c=quanbufenlei', function(s) {
					if (s.shi == 1) {
						that.fenleilie = s.shu;
					}
				});
			},
			Tiaojia(){
				var that = this;
				this.dialog=true;			
				this.$post("m="+this.value.mokuai+'&k=shangpin',this.so,function(s) {
					if (s.shi == 1) {
						that.shangpin = s.shu;
					}
				});
			},
			handleSelectionChange(e){
				this.Xuanzhong=e;
			},
			Queding(){			
				this.dialog=false;				
				for(var i in this.Xuanzhong){
					this.value.shu.push(this.Xuanzhong[i]);
				}
			},
			Shanchu_shu(i){
				this.value.shu.splice(i,1);
			}
			
		}		

	}
</script>
<link rel="stylesheet" href="Yangshi.css">
